import { Link } from 'react-router-dom';

const categoryLinks = [
  { to: '/category/movie', label: '电影' },
  { to: '/category/tv', label: '电视剧' },
  { to: '/category/variety', label: '综艺' },
  { to: '/category/all', label: '全部影视' },
];

const newsLinks = [
  { to: '/news', label: '最新资讯' },
  { to: '/search', label: '搜索影视' },
  { to: '/about', label: '关于我们' },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-foreground-900 md:mt-24">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4 lg:gap-12">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg font-extrabold text-foreground-950">
                黄色<span className="text-primary-500">影视</span>
              </span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700">
              专注高清电影、电视剧与综艺内容聚合，提供分类浏览、影视资讯与便捷检索体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <span className="cursor-default">影视分类</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categoryLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-500">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <span className="cursor-default">发现更多</span>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {newsLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="cursor-pointer text-sm text-foreground-700 transition-colors hover:text-primary-500">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              <span className="cursor-default">联系我们</span>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-700">
              <li>
                <a href="mailto:hello@huangseyingshi.com" className="cursor-pointer transition-colors hover:text-primary-500">
                  hello@huangseyingshi.com
                </a>
              </li>
              <li>
                <a href="mailto:support@huangseyingshi.com" className="cursor-pointer transition-colors hover:text-primary-500">
                  support@huangseyingshi.com
                </a>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <a href="https://weibo.com" target="_blank" rel="noreferrer" aria-label="微博" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-weibo-fill"></i>
              </a>
              <a href="https://www.bilibili.com" target="_blank" rel="noreferrer" aria-label="哔哩哔哩" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-bilibili-fill"></i>
              </a>
              <a href="https://www.douyin.com" target="_blank" rel="noreferrer" aria-label="抖音" className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-background-50/10 text-foreground-800 transition-colors hover:bg-primary-500 hover:text-background-50">
                <i className="ri-tiktok-fill"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 border-t border-background-50/10 pt-6">
          <p className="text-xs leading-relaxed text-foreground-700">
            免责声明：本站为影视内容展示演示站点，站内影视资料、播放区域及数据均为前端示例，不提供真实影视资源的播放与下载。
          </p>
          <div className="mt-4 flex flex-col gap-2 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
            <p>© {new Date().getFullYear()} 黄色影视 HuangseFilms. 保留所有权利。</p>
            <p>仅供学习与演示使用 · 内容版权归原作者所有</p>
          </div>
        </div>
      </div>
    </footer>
  );
}